/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Faq_Notes_Sync_QuestionInputs */

const en_mobile_faq_notes_sync_question = /** @type {(inputs: Mobile_Faq_Notes_Sync_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adding and Syncing Notes Across Platforms`)
};

const es_mobile_faq_notes_sync_question = /** @type {(inputs: Mobile_Faq_Notes_Sync_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar y sincronizar notas entre plataformas`)
};

/**
* | output |
* | --- |
* | "Adding and Syncing Notes Across Platforms" |
*
* @param {Mobile_Faq_Notes_Sync_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_faq_notes_sync_question = /** @type {((inputs?: Mobile_Faq_Notes_Sync_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Faq_Notes_Sync_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_faq_notes_sync_question(inputs)
	return en_mobile_faq_notes_sync_question(inputs)
});